let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("kJRtX")).then(() => parcelRequire('3TAdh'));